import { defineMessages } from '@transcend-io/internationalization';

export const navMenuMessages = defineMessages(
  'privacy-center.components.NavMenu.navMenu',
  {
    mobileNavMenu: { defaultMessage: 'Menu' },
    navToggleCloseButton: { defaultMessage: 'Close menu' },
    navToggleOpenButton: { defaultMessage: 'Open menu' },
  },
);
